var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    class: ("" + ((_vm.role == 'admin') ? 'col-md-2' : 'col-md-4'))
  }, [_c('label', [_vm._v("Zone "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.zoneLoading
    },
    on: {
      "update:active": function($event) {
        _vm.zoneLoading = $event
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zone),
      expression: "zone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('zone')
    },
    staticStyle: {
      "height": "42px"
    },
    attrs: {
      "name": "zone",
      "id": "zone"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.zone = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getHubData]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.zoneList), function(zone_obj) {
    return _c('option', {
      domProps: {
        "value": zone_obj.hubzoneid
      }
    }, [_vm._v(_vm._s(zone_obj.hubzonename))])
  })], 2)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('zone')),
      expression: "errors.has('zone')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Zone is required.")])], 1), _vm._v(" "), _c('div', {
    class: ("" + ((_vm.role == 'admin') ? 'col-md-4' : 'col-md-5'))
  }, [_c('label', [_vm._v("Hub / SVC "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.hubLoading
    },
    on: {
      "update:active": function($event) {
        _vm.hubLoading = $event
      }
    }
  }), _vm._v(" "), _c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'error': _vm.errors.has('HubId')
    },
    staticStyle: {
      "border": "1px solid #c2cfd6",
      "z-index": "999"
    },
    attrs: {
      "options": _vm.hubList,
      "placeholder": "Select Hub / Svc",
      "name": "HubId",
      "id": "HubId",
      "label": "HubName",
      "track-by": "HubID",
      "optionHeight": 100,
      "hide-selected": false
    },
    model: {
      value: (_vm.HubId),
      callback: function($$v) {
        _vm.HubId = $$v
      },
      expression: "HubId"
    }
  }, [_c('template', {
    slot: "noResult"
  }, [_c('p', [_vm._v("No Record Found.")])])], 2)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('HubId')),
      expression: "errors.has('HubId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Hub / SVC is required.")])], 1), _vm._v(" "), (_vm.role == 'admin') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("From ( Created ) Date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true
    },
    staticStyle: {
      "height": "42px"
    },
    attrs: {
      "id": "fromDate",
      "type": "date",
      "name": "fromDate"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "fdate"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.role == 'admin') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("To ( Created ) Date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true
    },
    staticStyle: {
      "height": "42px"
    },
    attrs: {
      "id": "toDate",
      "type": "date",
      "name": "toDate"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Clear")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "myResetModalRef",
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.ResetmodalShow),
      callback: function($$v) {
        _vm.ResetmodalShow = $$v
      },
      expression: "ResetmodalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('h5', {
    staticStyle: {
      "font-size": "1rem",
      "color": "red"
    }
  }, [_vm._v("Are you sure to " + _vm._s(_vm.resetType) + " for delivery date " + _vm._s(_vm.resetDD) + ".")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('center', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "background-color": "#20a8d8"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.hideResetModal('0', _vm.resetType)
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "background-color": "#f86c6b"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.hideResetModal('1', _vm.resetType)
      }
    }
  }, [_vm._v("No")])])], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Result  (  \n                            "), (_vm.resultCount > 0) ? _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.resultdate) + " : ")])]) : _vm._e(), _vm._v(" \n                            "), _c('font', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_c('span', {
    staticClass: "dot1"
  }), _vm._v(" System Closure\n                                "), _c('span', {
    staticClass: "dot2"
  }), _vm._v(" Tax Payment/Imprest\n                                "), _c('span', {
    staticClass: "dot3"
  }), _vm._v(" Amount Mismatched\n                                "), _c('span', {
    staticClass: "dot4"
  }), _vm._v(" RSC Vendor\n                            ")]), _vm._v("\n                              )\n                        ")], 1), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables scrolltb",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [(_vm.resultCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "13",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.CODLedgerReports), function(CODLedger_List, index) {
    return _c('tr', {
      class: ("" + ((CODLedger_List.createdby == 'schedular@xpressbees.com') || (CODLedger_List.deposittype == '' && ![366,367,168,169].includes(CODLedger_List.financereasonid)) ? 'scheduler' : '' || CODLedger_List.reasonid == 65 ? 'other' : '' || ([84,124,187,218,125].includes(CODLedger_List.financereasonid)) ? 'mismatched' : ([366,367,168,169].includes(CODLedger_List.financereasonid)) ? 'fnfrsc' : ''))
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.pageno + index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-edit text-successedit fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getSVCRowData(CODLedger_List)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(CODLedger_List.deliverydate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(CODLedger_List.bankdepositdate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(CODLedger_List.openingbalance))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(CODLedger_List.codamount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(CODLedger_List.bankdeposit))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(CODLedger_List.closingbalance))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(CODLedger_List.financereason))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(CODLedger_List.actualrecamt))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', [_vm._v(_vm._s(CODLedger_List.financeclosingamt))]), _vm._v(" "), _c('span', [(_vm.role == 'admin') ? _c('i', {
      staticClass: "fa fa-edit text-successedit fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "float": "right"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.editFC(CODLedger_List)
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(CODLedger_List.files.length > 0 && CODLedger_List.createdby != 'schedular@xpressbees.com' && CODLedger_List.othercharges == '0.00') ? _c('span', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer",
        "text-decoration": "underline"
      },
      attrs: {
        "id": ("" + ("vrl"+CODLedger_List.svcledgerid))
      },
      on: {
        "click": function($event) {
          _vm.showHideImages(CODLedger_List.svcledgerid, 'vrl')
        }
      }
    }, [_vm._v("Deposit")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": ("" + ("vri"+CODLedger_List.svcledgerid))
      }
    }, _vm._l((CODLedger_List.files), function(file) {
      return _c('a', {
        attrs: {
          "title": ("" + (file.name)),
          "href": ("" + (file.url))
        }
      }, [_c('i', {
        staticClass: "fa fa-download",
        staticStyle: {
          "font-size": "20px",
          "color": "#4b8cbb",
          "margin": "10px 10px 1px 1px"
        },
        attrs: {
          "aria-hidden": "true"
        }
      })])
    })), _vm._v(" "), ((CODLedger_List.reasonfiles.length > 0 && CODLedger_List.createdby != 'schedular@xpressbees.com')) ? _c('span', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer",
        "text-decoration": "underline"
      },
      attrs: {
        "id": ("" + ("vrrl"+CODLedger_List.svcledgerid))
      },
      on: {
        "click": function($event) {
          _vm.showHideImages(CODLedger_List.svcledgerid, 'vrrl')
        }
      }
    }, [_c('br'), _vm._v("Other")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": ("" + ("vrri"+CODLedger_List.svcledgerid))
      }
    }, _vm._l((CODLedger_List.reasonfiles), function(file) {
      return _c('a', {
        attrs: {
          "title": ("" + (file.name)),
          "href": ("" + (file.url))
        }
      }, [_c('i', {
        staticClass: "fa fa-download",
        staticStyle: {
          "font-size": "20px",
          "color": "#4b8cbb",
          "margin": "10px 10px 1px 1px"
        },
        attrs: {
          "aria-hidden": "true"
        }
      })])
    }))]), _vm._v(" "), (CODLedger_List.statusid == 1) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v("Open")]) : _vm._e(), _vm._v(" "), (CODLedger_List.statusid == 6) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v("Close")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(CODLedger_List.createdby))])])
  })], 2)]), _c('br'), _vm._v(" "), (_vm.resultCount > 0) ? _c('paginate', {
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '«',
      "next-text": '»',
      "container-class": 'pagination'
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('b-modal', {
    ref: "myClosureModalRef",
    on: {
      "ok": function($event) {
        _vm.FCModal = false
      }
    },
    model: {
      value: (_vm.FCModal),
      callback: function($$v) {
        _vm.FCModal = $$v
      },
      expression: "FCModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "width": "185%",
      "margin-left": "-25%"
    }
  }, [_c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('form', {
    attrs: {
      "id": "FCform"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onUpdate()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Update SVC Closure")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [(_vm.role == 'admin') ? _c('div', {
    staticClass: "col-lg-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("COD Receivable Amount")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codamount),
      expression: "codamount"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "disabled": _vm.upTyp == 2,
      "type": "text",
      "placeholder": "COD Receivable Amount",
      "name": "codamount",
      "id": "codamount",
      "onkeypress": "return event.charCode <= 57"
    },
    domProps: {
      "value": (_vm.codamount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codamount = $event.target.value
      }
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bank Deposit Date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.depdate),
      expression: "depdate"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "disabled": _vm.upTyp == 2,
      "type": "date",
      "placeholder": "Bank Deposit Date",
      "name": "depdate",
      "id": "depdate"
    },
    domProps: {
      "value": (_vm.depdate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.depdate = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bank Deposit Amount")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.depamount),
      expression: "depamount"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "disabled": _vm.upTyp == 2 || _vm.role !== 'admin',
      "type": "text",
      "placeholder": "Bank Deposit Amount",
      "name": "depamount",
      "id": "depamount",
      "onkeypress": "return event.charCode <= 57"
    },
    domProps: {
      "value": (_vm.depamount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.depamount = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Finance Reason")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.finreason),
      expression: "finreason"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "disabled": _vm.upTyp == 2 || _vm.statusid == 1,
      "name": "finreason"
    },
    domProps: {
      "value": _vm.finreason
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.finreason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.FinanceReasonList), function(finreason_obj) {
    return _c('option', {
      domProps: {
        "value": finreason_obj.ReasonsID
      }
    }, [_vm._v(_vm._s(finreason_obj.Reason))])
  })], 2)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Finance Confirmed Amount")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualrecamt),
      expression: "actualrecamt"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "disabled": _vm.upTyp == 2 || _vm.statusid == 1,
      "name": "actualrecamt",
      "id": "actualrecamt",
      "type": "text",
      "placeholder": "Finance Confirmed Amount",
      "onkeypress": "return event.charCode <= 57"
    },
    domProps: {
      "value": (_vm.actualrecamt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.actualrecamt = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), (_vm.role == 'admin') ? _c('div', {
    staticClass: "col-lg-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Finance Outstanding Amount")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.financeclosingamt),
      expression: "financeclosingamt"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "disabled": _vm.upTyp == 1,
      "name": "financeclosingamt",
      "id": "financeclosingamt",
      "type": "text",
      "placeholder": "Finance Outstanding Amount",
      "onkeypress": "return event.charCode <= 57"
    },
    domProps: {
      "value": (_vm.financeclosingamt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.financeclosingamt = $event.target.value
      }
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.createdby != 'schedular@xpressbees.com' && _vm.deposittype != '') ? _c('div', {
    staticClass: "col-lg-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Slip Type")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radio),
      expression: "radio"
    }],
    attrs: {
      "disabled": _vm.upTyp == 2,
      "type": "radio",
      "name": "radio",
      "value": "dps"
    },
    domProps: {
      "checked": _vm._q(_vm.radio, "dps")
    },
    on: {
      "__c": function($event) {
        _vm.radio = "dps"
      }
    }
  }), _vm._v("  Deposit Slip     \n                                                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radio),
      expression: "radio"
    }],
    attrs: {
      "disabled": _vm.upTyp == 2,
      "type": "radio",
      "name": "radio",
      "value": "reason"
    },
    domProps: {
      "checked": _vm._q(_vm.radio, "reason")
    },
    on: {
      "__c": function($event) {
        _vm.radio = "reason"
      }
    }
  }), _vm._v("  Dispute Slip\n                                                            ")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "cr"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.createdby != 'schedular@xpressbees.com' && _vm.deposittype != '') ? _c('div', {
    staticClass: "col-lg-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Upload Deposit/ Dispute Slip")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    class: {
      'form-control': true
    },
    attrs: {
      "disabled": _vm.upTyp == 2,
      "type": "file",
      "placeholder": "Upload Deposit/ Dispute Slip",
      "name": "depslip",
      "id": "depslip"
    },
    on: {
      "change": function($event) {
        _vm.onUpload()
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text",
    staticStyle: {
      "font-size": "11px",
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v("Note: For upload deposit/ dispute slip, no need to click submit.")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Comment")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    ref: "textarea",
    staticStyle: {
      "width": "100% !important"
    },
    attrs: {
      "rows": "2",
      "name": "comment",
      "id": "comment",
      "placeholder": "Enter Comment..."
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  })])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "rolefooter form-actions"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.subLoading
    },
    on: {
      "update:active": function($event) {
        _vm.subLoading = $event
      }
    }
  }), _vm._v(" "), (_vm.createdby != 'schedular@xpressbees.com' && _vm.deposittype != '') ? _c('b-button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "title": "Delete All Uploaded Slip"
    },
    on: {
      "click": function($event) {
        _vm.deleteDPS()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Reset Slip")]) : _vm._e(), _vm._v(" "), (_vm.createdby != 'schedular@xpressbees.com' && _vm.deposittype != '') ? _c('span', [_vm._v("  "), _c('b', [_vm._v("|")]), _vm._v("  ")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Submit")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('br'), _c('span', {
    staticClass: "text",
    staticStyle: {
      "font-size": "11px",
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("Note: On click of reset slip, all uploded slip will be removed including deposit & dispute so, before reset please backup old slips.")])], 1)])])], 1)])])])])])], 1)])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    staticClass: " fa fa-filter filter"
  }), _vm._v(" Reset - SVC Ledger\n                ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "80px"
    }
  }, [_c('b', [_vm._v("Action")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Delivery Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Deposit Date")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Opening Amount ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("COD Receivable ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Deposited Amount ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Closing Amount ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Finance Reason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Finance Confirmed ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Finance Outstanding ( "), _c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" )")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Deposit Slip")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Created by")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df7be2ec","hasScoped":true}!./src/views/components/svcreset/svcreset.component.html
// module id = 746
// module chunks = 1